export function formatProductDescription(product) {
  if (!product) return '';
  const details = [product.DESCRIPTION, product.COLOR].filter(Boolean).join(' / ');
  return details ? `${product.PARTNUM} - ${details}` : product.PARTNUM || '';
}

const VALID_UOMS = ['EA', 'BND', 'FT2'];

export function baseUomForProduct(product) {
  const uom = String(product?.UOM || 'EA')
    .trim()
    .toUpperCase();
  return VALID_UOMS.includes(uom) ? uom : 'EA';
}

export function priceForProduct(product, pricingLevelId, unit = baseUomForProduct(product)) {
  if (!product || !pricingLevelId) return null;
  const price = product.prices?.find((item) => item.PRICELISTID?.toUpperCase() === pricingLevelId?.toUpperCase());
  if (!price) return null;
  const baseUom = baseUomForProduct(product);
  const selectedUom = String(unit || baseUom)
    .trim()
    .toUpperCase();
  return selectedUom === 'FT2' && baseUom !== 'FT2' ? price.PRICESQFT : price.PRICEPC;
}

export function productSupportsFt2(product, pricingLevelId) {
  if (!product || baseUomForProduct(product) === 'FT2' || !pricingLevelId) return false;
  const price = product.prices?.find((item) => item.PRICELISTID?.toUpperCase() === pricingLevelId?.toUpperCase())?.PRICESQFT;
  return price !== null && price !== undefined && price !== '';
}

export function calculateLineAmount(line) {
  if (line?.LINETYPE === 'comment') return 0;
  const qty = Number(line?.QTY || 0);
  const price = Number(line?.UNITPRICE || 0);
  const discount = Number(line?.DISCOUNTPCT || 0);
  return qty * price * (1 - discount / 100);
}

export function calculateQuoteSubtotal(quote) {
  return (quote?.items || []).reduce((sum, line) => sum + calculateLineAmount(line), 0);
}

export function calculateQuoteTotal(quote) {
  const subtotal = calculateQuoteSubtotal(quote);
  const discountPct = Number(quote?.DISCOUNTPCT || 0);
  return subtotal * (1 - discountPct / 100);
}

function productForLine(line, quoteProducts = []) {
  if (!line?.PRODUCTID) return null;
  return quoteProducts.find((product) => product.PRODUCTID?.toUpperCase() === line.PRODUCTID?.toUpperCase()) || null;
}

export function calculateLineWeight(line, product) {
  if (line?.LINETYPE !== 'part' || !product) return 0;

  const weight = Number(product.WEIGHT);
  if (!weight) return 0;

  const qty = Number(line.QTY || 0);
  if (!qty) return 0;

  const unit = String(line.UNIT || 'EA')
    .trim()
    .toUpperCase();
  const baseUom = baseUomForProduct(product);

  if (unit === 'FT2' && baseUom !== 'FT2') {
    const piecesPerSqft = Number(product.PIECESPERSQFT);
    if (!piecesPerSqft) return 0;
    return qty * piecesPerSqft * weight;
  }

  return qty * weight;
}

export function calculateQuoteTotalWeight(quote, quoteProducts = []) {
  return (quote?.items || []).reduce((sum, line) => {
    const product = productForLine(line, quoteProducts);
    return sum + calculateLineWeight(line, product);
  }, 0);
}

export function formatCurrency(value) {
  const number = Number(value || 0);
  return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
